import type { ReactNode } from "react";

interface IListItemProps {
  title: string;
  value: string | number | ReactNode | undefined | any;
  className?: string;
  delimiter?: string;
}

export function ListItem({
  title,
  value,
  className,
  delimiter = ":",
}: IListItemProps): JSX.Element {
  if (!value || (typeof value === "string" && value?.includes("undefined"))) {
    return null;
  }
  return (
    <div
      className={`${
        className || ""
      } flex flex-row xl:flex-col  md:items-center xl:items-start md:justify-normal gap-2 my-2 xl:my-3`}
    >
      <span className="font-semibold text-gray-900">
        {title ? `${title}${delimiter}` : ""}
      </span>

      <span className="xl:ml-5">{value || ""}</span>
    </div>
  );
}

export function FlexListItem({ title, value }: IListItemProps): JSX.Element {
  return (
    <div className="flex flex-row lg:flex-col gap-2 my-2 lg:my-3">
      <span className="font-semibold ">{title || ""}</span>
      <span className="ml-5 mt-1 min-h-[45px] ">{value || ""}</span>
    </div>
  );
}
